import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { LoadingService, AlertService } from 'ngx-kuv-tools';
import { ConfigService } from 'src/app/utils/config/config.service';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';
import { ModalDeleteComponent } from 'src/app/utils/modal-delete/modal-delete.component';
import { SesionService } from 'src/app/utils/sesion/sesion.service';
import { RevisionUpdateComponent } from '../../revision/revision-update/revision-update.component';
import { RevisionViewComponent } from '../../revision/revision-view/revision-view.component';
import { RevisionService } from '../../revision/revision.service';


@Component({
  selector: 'app-vehiculo-historico',
  templateUrl: './vehiculo-historico.component.html',
  styleUrls: ['./vehiculo-historico.component.scss']
})
export class VehiculoHistoricoComponent implements OnInit {
  @Input() element: any;
  url: string = '';
  excel: string = '';

  reloadEmitter: EventEmitter<string> = new EventEmitter();

  filtros = [
    {
      label: 'Desde',
      column: 'fecha',
      op: 'gte',
      type: 'date'
    },
    {
      label: 'Hasta',
      column: 'fecha',
      op: 'lte',
      type: 'date'
    },
    {
      label: 'Tipo',
      column: 'tipo',
      op: 'like',
    },
    {
      label: 'Kilometraje',
      column: 'kilometraje',
      op: 'like',
    },
    {
      label: 'Encargado',
      column: 'encargado',
      op: 'like',
    },
    {
      label: 'Estimada Desde',
      column: 'fecha_estimada',
      op: 'gte',
      type: 'date'
    },
    {
      label: 'Estimada Hasta',
      column: 'fecha_estimada',
      op: 'lte',
      type: 'date'
    },
  ]

  acciones = [
    {
      label: 'Ver',
      icon: 'eye',
      action: (element: any, index: number) => {
        this.view(element)
      }
    },
    {
      label: 'Editar',
      icon: 'pen',
      action: (element: any, index: number) => {
        this.edit(element)
      }
    },
    {
      icon: "trash",
      label: "Eliminar",
      action: (element: any, index: number) => {
        this.delete(element);
      },
      hide: (element: any, index: number) => {
      }
    }
  ]

  columnas = [
    {
      label: 'Fecha',
      attribute: 'fecha',
      width: 1,
      responsive: ['SM'],
      value: (element: any, index: number) => {
        return this.formatter.dateFormat(element.fecha);
      }
    },
    {
      label: 'Patente',
      attribute: 'patente',
      width: 1,
      responsive: ['XS', 'SM', 'MD'],
      value: (element: any, index: number) => {
        return element.vehiculo.patente;
      }
    },
    {
      label: 'Tipo Servicio',
      attribute: 'tipo',
      width: 1,
      responsive: ['SM', 'MD'],
      value: (element: any, index: number) => {
        return element.tipo_revision?.nombre;
      }
    },
    {
      label: 'Fecha Estimada',
      attribute: 'fecha_estimada',
      width: 1,
      responsive: ['SM'],
      value: (element: any, index: number) => {
        return this.formatter.dateFormat(element.fecha_estimada);
      }
    },
  ]

  constructor(
    private config: ConfigService,
    private modalService: NgbModal,
    public loading: LoadingService,
    private alerts: AlertService,
    public service: RevisionService,
    public sesion: SesionService,
    public formatter: FormatterService,
    public activeModal: NgbActiveModal,
  ) { }

  ngOnInit(): void {
    this.url = this.config.apiUrl + this.service.controller + 'ver-historico/' + this.element.id;
    this.excel = this.config.apiUrl + this.service.controller + 'historico-excel/' + this.element.id;
  }

  view(element: any): void {
    const modalRef = this.modalService.open(RevisionViewComponent, { windowClass: 'clear-modal', size: 'xl', scrollable: true });
    modalRef.componentInstance.element = element;
    modalRef.result.then((result: any) => {
      this.loadData();
    }, (reason: any) => { });
  }

  edit(element: any): void {
    const modalRef = this.modalService.open(RevisionUpdateComponent, { windowClass: 'clear-modal', size: 'xl', scrollable: true, backdrop: 'static' });
    modalRef.componentInstance.element = element;
    modalRef.result.then((result: any) => {
      this.loadData();
    }, (reason: any) => { });
  }

  toggle(element: any): void {
    if (element.id == element.estado) {
      this.alerts.addAlert("No puede desactivar o activar su propia cuenta.", "danger");
      return;
    }
    if (element.estado == 0) {
      this.loading.show();
      this.service.activate(element.id).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.loadData();
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido activar el registro.", "danger");
        }
      });
      return;
    }
    if (element.estado == 1) {
      this.loading.show();
      this.service.deactivate(element.id).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.loadData();
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido desactivar el registro.", "danger");
        }
      });
    }
  }

  delete(element: any): void {
    const modalRef = this.modalService.open(ModalDeleteComponent, { windowClass: 'clear-modal', size: 'md', scrollable: true, backdrop: 'static' });
    modalRef.componentInstance.titulo = 'Eliminar Vehículo';
    modalRef.componentInstance.texto = '¿Seguro que desea eliminar este registro?';
    modalRef.componentInstance.textoAceptar = 'Eliminar';
    modalRef.result.then((result) => {
      this.loading.show();
      this.service.delete(element.id).subscribe({
        next: (res: any) => {
          this.loading.hide();
          this.loadData();
          this.alerts.addAlert("Vehículo eliminado con éxito.", "success");
        },
        error: (err: any) => {
          console.error(err);
          this.loading.hide();
          this.alerts.addAlert("No se ha podido eliminar el registro del vehículo.", "danger");
        }
      });
    }, (reason) => { });
  }

  loadData(): void {
    this.reloadEmitter.emit();
  }
}
